<template>
    <div
        class="vault-card my-auto"
        :class="itemCss + ' ' + (show ? loadStatus : '')"
    >
        <div
            class="hide-mobile user-select-none pb-2"
            :class="{ hideto: !show }"
            v-on:click="show = !show"
        >
            <div v-if="show">hide</div>
            <div v-if="!show">details</div>
            <img
                src="/images/icons/chevron.svg"
                :class="{ chevrot: !show }"
                class="color-svg"
                alt=""
            />
        </div>
        <div @click="goToVault(item)" class="d-flex" style="width: 100%">
            <div class="header-title">
                <div class="text-header">
                    <span v-if="item.is_il">PHYSICAL -</span>
                    {{ item.type.replace("_", "-") }}
                </div>
            </div>
            <!-- <div class="linehide" v-if="show"></div> -->
            <b-row no-gutters class="banner-box">
                <b-col cols="6" lg="3" class="mob-top" style="display: flex">
                    <img
                        class="icon-mob"
                        :src="itemIcon"
                        :alt="item.token + ' image'"
                    />
                    <b-row
                        no-gutters
                        class="text-title mbl-width left-box-desc"
                    >
                        <b-col cols="12" class="title-1 text-left">
                            {{ this.generateVaultName(item) }}
                        </b-col>
                        <b-col cols="12" class="title-2 text-left">
                            <div v-if="item.is_il">PHYSICAL</div>
                            {{ item.type.replace("_", "-") }}
                        </b-col>
                        <b-col cols="12" class="title-2 text-left">
                            {{ item.time_period }}
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="6" lg="3" class="mob-top" style="display: flex">
                    <b-row
                        no-gutters
                        class="text-title center-text right-box-apy apy-p p-0"
                    >
                        <b-col
                            cols="12"
                            class="title-3 right-text-mobile"
                            :id="`apy-${keyItem}`"
                        >
                            {{
                                0 > item.apy
                                    ? `${moneyFormat(apy)}`
                                    : `+${moneyFormat(apy)}`
                            }}%
                        </b-col>
                        <b-col cols="12" class="title-4 right-text-mobile">
                            Current Projected Yield (APY)
                        </b-col>
                    </b-row>
                </b-col>

                <b-col v-if="show" cols="12" lg="3" class="col-exp">
                    <b-row no-gutters class="text-expiry">
                        <b-col cols="12" class="mb-mob mt-1">
                            <div class="linehide" v-if="show"></div>
                            <b-row no-gutters>
                                <b-col cols="6" md="5" class="text-left">
                                    Time to expiry:
                                </b-col>
                                <b-col cols="6" md="7" class="text-right">
                                    <count-down
                                        v-if="item"
                                        :expiry="item.vault_detail.expiry"
                                        :vault="item"
                                        :id="`time-of-expiry-${keyItem}`"
                                    />
                                    <!--{{ getExpiry }}-->
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="12" class="mb-mob">
                            <b-row no-gutters>
                                <b-col cols="5" class="text-left">
                                    Strike price:
                                </b-col>
                                <b-col
                                    cols="7"
                                    class="text-right"
                                    :id="`price-strike-${keyItem}`"
                                >
                                    {{ getStrike }}
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col
                    v-if="show"
                    cols="12"
                    lg="3"
                    class="col-exp margin-left-deposit-max-desktop"
                >
                    <feature-fault-bar
                        v-if="loadStatus == 'finish'"
                        :position="myPosition"
                        :deposits="item.vault_detail.computed_deposit"
                        :max_deposits="item.max_deposit"
                        :token="item.token"
                        :type="item.type"
                        :network="item.network"
                        :keyItem="keyItem"
                        :currBalance="currBalance"
                        :real_token_symbol="item.real_token_symbol"
                    >
                    </feature-fault-bar>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import featureFaultBar from "./featureFaultBar.vue";
import { mapState, mapGetters } from "vuex";

import moment from "moment";

export default {
    data() {
        return {
            show: true,
            windowWidth: 0,
            loadStatus: "loading",
            vault: null,
            myPosition: 0,
            currBalance: 0
        };
    },
    components: {
        featureFaultBar
    },
    props: {
        item: {
            type: Object,
            default: () => {
                return {};
            }
        },
        keyItem: {
            type: Number
        }
    },
    computed: {
        ...mapState(["wallet"]),
        ...mapGetters({
            walletProvider: "wallet/getWalletProvider",
        }),
        getStrike() {
            if (this.item == null) return "---";
            return this.formatCurrency(+this.item.vault_detail.strike_price);
        },
        getExpiry() {
            if (this.item == null) return "---";
            return moment().to(this.item.vault_detail.expiry);
        },
        itemCss() {
            //return `${this.item.nut}-card`;
            return `${this.item.color}-card`;
        },
        itemIcon() {
            return `/images/crypto-icons/icon-coin-${this.item.token}.svg`;
        },
        apy() {
            if (this.item.apy == 0) return 0;
            else return parseFloat(this.item.apy).toFixed(2);
        }
    },
    async mounted() {
        this.vault = this.item;
        // this.$nextTick(function() {
        //     window.addEventListener("resize", this.getWidthChange);
        //     this.getWidthChange();
        // });
        this.getWidthChange();
        //window.addEventListener("resize", this.getWidthChange);
        this.loadVaultData();
        this.setCurrentBalance();
    },
    watch: {
        item: function(newVault) {
            //detect changes in vault and update component
            this.vault = newVault;
            this.loadVaultData();
            this.setCurrentBalance();
        }
    },
    methods: {
        moment,
        async getVaultPosition() {
            let myPositionData = {};
            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.item.real_token_symbol &&
                    item.network == this.item.network
            );
            if (token == undefined || !this.walletProvider) return 0;

            myPositionData = await this.$store.dispatch(
                "vaults/getMyPosition",
                {
                    vault: this.item,
                    decimals: token.decimals
                }
            );

            if (myPositionData.activeDeposit) return this.moneyFormat(myPositionData.activeDeposit);
            return 0;

            // if (
            //     this.item.vault_detail.epoch > myPositionData.queuedEpoch &&
            //     myPositionData.queuedEpoch != 0
            // ) {
            //     return myPositionData.queuedDeposits;
            // } else if (
            //     this.item.vault_detail.epoch == myPositionData.queuedEpoch
            // ) {
            //     return myPositionData.queuedDeposits;
            // } else if (
            //     myPositionData.queuedEpoch == 0 &&
            //     myPositionData.position > 0
            // ) {
            //     return myPositionData.position;
            // } else {
            //     if(myPositionData.deposit) return this.moneyFormat(myPositionData.deposit/token.decimals);
            //     return 0;
            // }
        },
        formatCurrency(val) {
            const formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            return formatter.format(val);
        },
        async loadVaultData() {
            this.myPosition = await this.getVaultPosition();
            setTimeout(() => {
                this.loadStatus = "animating";

                setTimeout(() => {
                    this.loadStatus = "finish";
                }, 600);
            }, 600);

            return;
        },
        goToVault({ chain_id, contract_address }) {
            this.$router.push(`/basic/vaults/${chain_id}/${contract_address}`);
        },
        getWidthChange(event) {
            this.windowWidth = document.documentElement.clientWidth;
            //this.show = false;
            if (this.windowWidth >= 992) {
                this.show = true;
            } else {
                this.show = false;
            }
        },
        async setCurrentBalance() {
            if (this.vault !== undefined) {
                const token = this.$store.state.wallet.tokens.find(
                    a =>
                        a.symbol == this.vault.real_token_symbol &&
                        a.network == this.vault.network
                );

                if (token == undefined) return;

                this.currBalance = await this.$store.dispatch(
                    "vaults/getVaultCurrentDeposit",
                    {
                        vault_contract: this.vault.contract_address,
                        token: token,
                        vault: this.vault
                    }
                );
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.getWidthChange);
    }
};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";

.margin-left-deposit-max-desktop {
    @media only screen and (min-width: 992px) {
        margin-left: 1.38889vw;
    }
}

.right-text-mobile {
    text-align: right;

    @media only screen and (min-width: 768px) {
        text-align: center;
    }
}

.fault-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* gap: 30px; */

    .vault-card-parent {
        &:not(:first-child) {
            margin-top: 30px;

            @media only screen and (min-width: 992px) {
                margin-top: 2.0833333333333335vw;
            }
        }
    }
}
.vault-card {
    width: 100%;
    height: auto;
    margin: auto;
    cursor: pointer;
    position: relative;
    display: flex;
    justify-content: center;
    z-index: 30;
    padding: 20px;
    // min-height: 103px;
    background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.1) 0%,
        rgba(255, 255, 255, 0) 100%
    );
    border-radius: 0.8vmax;
    -webkit-transition: background 2s; /* For Safari 3.0 to 6.0 */
    transition: background 2s; /* For modern browsers */
    transition: max-width ease-in-out 0.6s;
    margin-top: 30px !important;

    @media only screen and (min-width: 992px) {
        /* max-width: 986px; */
        /* max-height: 103px; */
        max-width: 68.47222222222223vw;
        max-height: 20vw;

        height: 100%;

        &:not(:first-child) {
            margin-top: 2.0833333333333335vw !important;
        }
    }

    &.loading {
        max-width: 30vw;

        & .col-exp {
            display: none;
        }

        & .mob-top {
            max-width: 50%;
            margin: 0px;
        }

        & .mob-top.col-lg-3.col-6:nth-child(2) {
            margin: 0px;
        }
    }

    &.animating {
        & .col-exp {
            display: none;
        }
    }

    &:hover {
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.2) 0%,
            rgba(255, 255, 255, 0.1) 100%
        );
    }
    //border-image-source: linear-gradient(135.68deg, rgba(255, 255, 255, 0.11) 2.53%, rgba(255, 255, 255, 0.29) 92.19%);
    .header-title {
        position: absolute;
        display: table;
        left: 50%;
        transform: translate(-50%, -50%);
        top: 0%;
        //width: 111px;
        padding: 8px 12px;
        height: 26px;
        background: $primary-5;
        box-sizing: border-box;
        border-radius: 0.3vmax;
        align-items: center;
        text-align: center;

        .text-header {
            font-family: Bungee Inline;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 10px;
            text-align: center;
            text-transform: uppercase;
            margin: auto;
            display: table-cell;
            vertical-align: middle;
        }
    }
    a,
    a:hover {
        text-decoration: none !important;
    }
    .apy-p {
        padding-right: 15.365%;
    }
    .banner-box {
        margin: auto;
        padding: 0;
        width: 100%;
    }
    .text-title {
        font-family: Bungee;
        font-style: normal;
        font-weight: normal;
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: $primary-4;

        &.left-box-desc {
            .title-1 {
                @media only screen and (min-width: 1440px) {
                    font-size: 20px;
                    line-height: 10px;
                }
                @media only screen and (min-width: 2500px) {
                    font-size: calc(22px + 0.4vw);
                    line-height: inherit;
                }
            }
            .title-2 {
                @media only screen and (min-width: 1440px) {
                    font-size: 12px;
                    line-height: 10px;
                }
                @media only screen and (min-width: 2500px) {
                    font-size: calc(14px + 0.2vw);
                    line-height: calc(15px + 0.2vw);
                }
            }
            .title-3 {
                @media only screen and (min-width: 1440px) {
                    font-size: 12px;
                    line-height: 10px;
                }
            }
        }

        &.right-box-apy {
            .title-3 {
                @media only screen and (min-width: 1440px) {
                    /* font-size: 36px;
                    line-height: 32px; */
                    font-size: 2vw;
                    line-height: 2.2222222222222223vw;
                }
                /* @media only screen and (min-width: 2500px) {
                    font-size: calc(36px + 0.6vw);
                    line-height: calc(32px + 1vw);
                } */
            }
            .title-4 {
                @media only screen and (min-width: 1440px) {
                    /* font-size: 10px;
                    line-height: 13px; */
                    font-size: 0.6944444444444444vw;
                    line-height: 0.9027777777777778vw;
                }
                /* @media only screen and (min-width: 2500px) {
                    font-size: calc(10px + 0.2vw);
                    line-height: calc(13px + 0.2vw);
                } */
            }
        }

        .title-1 {
            font-size: 1.53vw; //1.528vmax;
            line-height: 1.49vmax;
        }
        .title-2 {
            // font-size: 14px;
            font-size: 0.975vw; //$text-normal;
            line-height: calc(#{$text-normal} + 6px);
            // line-height: 20px;
        }
        .title-3 {
            //font-size: 34px;
            font-size: 2.5vw; //$big-text;
            line-height: calc(#{$big-text} - 2px);
            // line-height: 32px;
        }
        .title-4 {
            margin-top: 5px;
            font-family: Exo;
            font-weight: 600;
            // font-size: 10px;
            font-size: 0.695vw; //$small-x-text;
            line-height: 13px;
        }
    }
    .text-expiry {
        width: inherit;
        font-family: Exo;
        font-style: normal;
        font-weight: normal;
        // font-size: 12px;
        font-size: 0.835vw; //$small-text;
        line-height: 1.5vmax;
        //text-align: center;
        color: $primary-4;
        padding: 0px 10px;
        margin: auto;

        @media only screen and (min-width: 1440px) {
            font-size: 0.8333333333333334vw;
            line-height: 1.5277777777777777vw;
        }
    }
    .center-text {
        margin: auto;
    }
    .col-exp {
        display: flex;
    }
    .icon-mob {
        max-height: 39px;
        max-width: 39px;
        width: 100%;
        height: 100%;
        margin: auto;
        margin-right: 10px;

        @media only screen and (min-width: 576px) {
            max-width: 54px;
            max-height: 54px;
            margin: auto;
            margin-left: 0;
            margin-right: 1.3888888888888888vw;
        }

        @media only screen and (min-width: 1440px) {
            max-width: 3.75vw;
            max-height: 3.75vw;
        }

        @media only screen and (min-width: 2048px) {
            max-width: 2.75vw;
            max-height: 2.75vw;
        }
    }
    //&.acord-card {
    &.green-card {
        border: 1px solid $primary-1;
        box-shadow: 1px 3px 15px 1px rgba(110, 226, 159, 0.15);
        .header-title {
            border: 1px solid $primary-1;
            box-shadow: 2px 0px 20px rgba(110, 226, 159, 0.25);
            .text-header {
                color: $primary-1;
            }
        }
        .apy-p {
            color: #b6f7d1 !important;
        }
        .progress {
            .progress-bar {
                background: $primary-1 !important;
                opacity: 0.8;
            }
        }
        .hide-mobile {
            color: $primary-1;
        }
        .linehide {
            border-top: 0.7px solid $primary-1;
        }
        .color-svg {
            filter: invert(75%) sepia(48%) saturate(403%) hue-rotate(90deg)
                brightness(99%) contrast(86%);
        }
    }
    //&.walnut-card {
    &.orange-card {
        border: 1px solid $primary-3;
        box-shadow: 1px 3px 15px 1px rgba(220, 152, 21, 0.15);
        .header-title {
            border: 1px solid $primary-3;
            box-shadow: 2px 0px 20px rgba(220, 152, 21, 0.25);
            .text-header {
                color: $primary-3;
            }
        }
        .apy-p {
            color: #f7e1b6 !important;
        }
        .progress {
            .progress-bar {
                background: $primary-3 !important;
                opacity: 0.8;
            }
        }
        .hide-mobile {
            color: $primary-3;
        }
        .linehide {
            border-top: 0.3px solid $primary-3;
        }
        .color-svg {
            filter: invert(56%) sepia(99%) saturate(456%) hue-rotate(0deg)
                brightness(95%) contrast(84%);
        }
    }

    &.light-orange-card {
        border: 1px solid $light-orange;
        box-shadow: 1px 3px 20px 1px rgba(220, 152, 21, 0.4);
        .header-title {
            border: 1px solid $light-orange;
            box-shadow: 2px 0px 20px rgba(220, 152, 21, 0.3);
            .text-header {
                color: $light-orange;
            }
        }
        .apy-p {
            color: #ffad4c !important;
        }
        .progress {
            .progress-bar {
                background: $light-orange !important;
                opacity: 0.8;
            }
        }
        .hide-mobile {
            color: $light-orange;
        }
        .linehide {
            border-top: 0.3px solid $light-orange;
        }
        .color-svg {
            filter: invert(46%) sepia(100%) saturate(3279%) hue-rotate(20deg)
                brightness(102%) contrast(102%);
        }
    }
    //&.almond-card {
    &.blue-card {
        border: 1px solid $primary-2;
        box-shadow: 1px 3px 15px 1px rgba(97, 113, 255, 0.15);
        .header-title {
            border: 1px solid $primary-2;
            box-shadow: 2px 0px 20px rgba(97, 113, 255, 0.25);
            .text-header {
                color: $primary-2;
            }
        }
        .apy-p {
            color: #b6bcf7 !important;
        }
        .progress {
            .progress-bar {
                background: $primary-2 !important;
                opacity: 0.8;
            }
        }
        .hide-mobile {
            color: $primary-2;
        }
        .linehide {
            border-top: 0.3px solid $primary-2;
        }
        .color-svg {
            filter: invert(46%) sepia(100%) saturate(3279%) hue-rotate(219deg)
                brightness(102%) contrast(102%);
        }
    }

    &.light-blue-card {
        border: 1px solid $light-blue;
        box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        .header-title {
            border: 1px solid $light-blue;
            box-shadow: 2px 0px 20px rgba(110, 226, 159, 0.25);
            .text-header {
                color: $light-blue;
            }
        }
        .apy-p {
            color: #99d4ff !important;
        }
        .progress {
            .progress-bar {
                background: $light-blue !important;
                opacity: 0.8;
            }
        }
        .hide-mobile {
            color: $light-blue;
        }
        .linehide {
            border-top: 0.3px solid $light-blue;
        }
        .color-svg {
            filter: invert(46%) sepia(100%) saturate(3279%) hue-rotate(200deg)
                brightness(102%) contrast(102%);
        }
    }

    &.light-purple-card {
        border: 1px solid $light-purple;
        box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        .header-title {
            border: 1px solid $light-purple;
            box-shadow: 2px 0px 20px rgba(110, 226, 159, 0.25);
            .text-header {
                color: $light-purple;
            }
        }
        .apy-p {
            color: #d060f7 !important;
        }
        .progress {
            .progress-bar {
                background: $light-purple !important;
                opacity: 0.8;
            }
        }
        .hide-mobile {
            color: $light-purple;
        }
        .linehide {
            border-top: 0.3px solid $light-purple;
        }
        .color-svg {
            filter: invert(46%) sepia(100%) saturate(3279%) hue-rotate(200deg)
                brightness(102%) contrast(102%);
        }
    }

    &.light-pink-card {
        border: 1px solid $light-pink;
        box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        .header-title {
            border: 1px solid $light-pink;
            box-shadow: 2px 0px 20px rgba(110, 226, 159, 0.25);
            .text-header {
                color: $light-pink;
            }
        }
        .apy-p {
            color: $light-pink !important;
        }
        .progress {
            .progress-bar {
                background: $light-pink !important;
                opacity: 0.8;
            }
        }
        .hide-mobile {
            color: $light-pink;
        }
        .linehide {
            border-top: 0.3px solid $light-pink;
        }
        .color-svg {
            filter: invert(46%) sepia(100%) saturate(3279%) hue-rotate(200deg)
                brightness(102%) contrast(102%);
        }
    }

    &.light-lime-card {
        border: 1px solid $light-lime;
        box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        .header-title {
            border: 1px solid $light-lime;
            box-shadow: 2px 0px 20px rgba(110, 226, 159, 0.25);
            .text-header {
                color: $light-lime;
            }
        }
        .apy-p {
            color: $light-lime !important;
        }
        .progress {
            .progress-bar {
                background: $light-lime !important;
                opacity: 0.8;
            }
        }
        .hide-mobile {
            color: $light-lime;
        }
        .linehide {
            border-top: 0.3px solid $light-lime;
        }
        .color-svg {
            filter: invert(46%) sepia(100%) saturate(3279%) hue-rotate(200deg)
                brightness(102%) contrast(102%);
        }
    }

    &.light-yellow-card {
        border: 1px solid $light-yellow;
        box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        .header-title {
            border: 1px solid $light-yellow;
            box-shadow: 2px 0px 20px rgba(110, 226, 159, 0.25);
            .text-header {
                color: $light-yellow;
            }
        }
        .apy-p {
            color: $light-yellow !important;
        }
        .progress {
            .progress-bar {
                background: $light-yellow !important;
                opacity: 0.8;
            }
        }
        .hide-mobile {
            color: $light-yellow;
        }
        .linehide {
            border-top: 0.3px solid $light-yellow;
        }
        .color-svg {
            filter: invert(46%) sepia(100%) saturate(3279%) hue-rotate(200deg)
                brightness(102%) contrast(102%);
        }
    }

    &.light-purple-2-card {
        border: 1px solid $light-purple-2;
        box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        .header-title {
            border: 1px solid $light-purple-2;
            box-shadow: 2px 0px 20px rgba(110, 226, 159, 0.25);
            .text-header {
                color: $light-purple-2;
            }
        }
        .apy-p {
            color: $light-purple-2 !important;
        }
        .progress {
            .progress-bar {
                background: $light-purple-2 !important;
                opacity: 0.8;
            }
        }
        .hide-mobile {
            color: $light-purple-2;
        }
        .linehide {
            border-top: 0.3px solid $light-purple-2;
        }
        .color-svg {
            filter: invert(46%) sepia(100%) saturate(3279%) hue-rotate(200deg)
                brightness(102%) contrast(102%);
        }
    }

    &.red-card {
        border: 1px solid $primary-6;
        box-shadow: 1px 3px 15px 1px rgba(97, 113, 255, 0.15);
        .header-title {
            border: 1px solid $primary-6;
            box-shadow: 2px 0px 20px rgba(97, 113, 255, 0.25);
            .text-header {
                color: $primary-6;
            }
        }
        .apy-p {
            color: #f7b4b4 !important;
        }
        .progress {
            .progress-bar {
                background: $primary-6 !important;
                opacity: 0.8;
            }
        }
        .hide-mobile {
            color: $primary-6;
        }
        .linehide {
            border-top: 0.3px solid $primary-6;
        }
        .color-svg {
            filter: invert(46%) sepia(100%) saturate(3279%) hue-rotate(330deg)
                brightness(102%) contrast(102%);
        }
    }
}

.hide-mobile {
    display: flex;
    cursor: pointer;
    position: absolute;
    font-family: Exo;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 13px;
    text-align: center;
    text-transform: uppercase;
    top: 48%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;

    @media only screen and (min-width: 992px) {
        &,
        &.linehide {
            display: none;
        }
    }
}
.hideto {
    top: 89%;

    @media only screen and (min-width: 992px) {
        .hideto {
            top: 0;
        }
    }
}

@media screen and (min-width: 0px) and (max-width: 768px) {
    .fault-cont {
        /* gap: 22px; */

        .vault-card-parent {
            &:not(:first-child) {
                margin-top: 22px;
            }
        }
    }
    .vault-card {
        width: 100% !important;
        border-radius: 10px;
        padding: 12px;

        &:not(:first-child) {
            margin-top: 22px !important;
        }

        .header-title {
            width: fit-content;
            height: inherit;
            border-radius: 4px;
        }
        .mbl-width {
            width: 60%;
        }
        .text-title {
            margin-left: 5px;
            .title-1 {
                font-size: 16px !important;
                line-height: 16px !important;
            }
            .title-2 {
                font-size: 12px !important;
                line-height: 16px !important;
            }
            .title-3 {
                font-size: 26px !important;
                line-height: 31px !important;
            }
            .title-4 {
                font-size: 8px !important;
                line-height: 11px !important;
            }
        }
        .text-expiry {
            font-weight: 600 !important;
            font-size: 10px !important;
            line-height: 18px !important;
            padding: 0 !important;
            margin: auto 0;
        }
        .apy-p {
            padding-right: 0 !important;
            padding-left: 20px;
        }
        .col-exp {
            display: unset !important;
        }
        .mob-top {
            margin-bottom: 15px;

            img ~ .text-title {
                width: 150px;
            }
        }
        .chevrot {
            transform: rotate(180deg);
        }
        .mb-mob {
            margin-bottom: 10px;
        }
        .banner-box {
            padding: 12px 0 0 !important;
        }
    }
}

.linehide {
    display: block;
    position: absolute;
    /* width: calc(100% - 20px); */
    /* top: 40%; */
    width: 100%;
    top: -8px;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;

    @media only screen and (min-width: 992px) {
        display: none;
    }
}

.mob-top.col-lg-3.col-6:nth-child(1) {
    @media only screen and (min-width: 992px) {
        flex-basis: 15.76388888888889vw;
    }
}

.mob-top.col-lg-3.col-6:nth-child(2) {
    @media only screen and (min-width: 992px) {
        flex-basis: 14.597222vw;
    }

    @media only screen and (min-width: 1440px) {
        /* margin: 0 2.0833333333333335vw 0 -2.0833333333333335vw; */
        margin: 0 1.3888888888888888vw 0 -0.6944444444444444vw;
    }

    @media only screen and (min-width: 2000px) {
        margin: 0 3.515625vw 0 -3.515625vw;
    }
}
</style>
